import React from "react";
import { Package, FileCode } from "lucide-react";
import CodeBlock from "../components/CodeBlock";
import { Card } from "../components/ui/card";

const Library = () => {
  return (
    <div className="prose prose-invert max-w-none">
      {/* Header */}
      <div className="not-prose mb-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-medium mb-4">
          <Package className="h-4 w-4" />
          C# Library
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          AxisNet C# Library
        </h1>
        <p className="text-xl text-slate-400">
          Enterprise-grade foundation classes, interfaces, and helpers for
          building clean, maintainable domain models.
        </p>
      </div>

      {/* Overview */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold text-white mb-4">Overview</h2>
        <p className="text-slate-300 mb-6">
          The AxisNet library provides a solid foundation for implementing
          Domain-Driven Design principles in your .NET applications. It includes
          base classes, interfaces, and utilities that handle common concerns
          like entity identity, domain events, auditing, and soft deletes.
        </p>

        <div className="not-prose">
          <Card className="p-6 bg-emerald-900/20 border-emerald-500/30 mb-6">
            <p className="text-sm text-emerald-300">
              <strong>Installation:</strong>
            </p>
            <div className="mt-2">
              <CodeBlock code="dotnet add package AxisNet.Framework" />
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Library;
